module.exports = __webpack_public_path__ + "img/ic-pwp-app-change.svg";